import icon1 from '../../../Assets/Icons/help1.svg';
import icon2 from '../../../Assets/Icons/help2.svg';
import icon3 from '../../../Assets/Icons/help3.svg';

import icon4 from '../../../Assets/Icons/help4.svg';
import icon5 from '../../../Assets/Icons/help5.svg';
import icon6 from '../../../Assets/Icons/help6.svg';
import icon7 from '../../../Assets/Icons/help7.svg';
import icon8 from '../../../Assets/Icons/help8.svg';
import icon9 from '../../../Assets/Icons/help9.svg';
import icon10 from '../../../Assets/Icons/help10.svg';


export const helpData = [
    {
        icon:icon1,
        cBg:"#632af21c",
        title:"Collaboration",
        desc1:"How to archive and unarchive your projects",
        desc2:"How to archive and unarchive your projects"
    },
    {
        icon:icon2,
        cBg:"#17a8ec59",
        title:"User Testing",
        desc1:"An introduction to User Testing",
        desc2:"How do participants take a user test on desktop, iPhone, iPad and Android devices?"
    },
    {
        icon:icon3,
        cBg:"#ff4f5b60",
        title:"Prototyping",
        desc1:"A guide to creating your first prototype",
        desc2:"How to use sections"
    },
    {
        icon:icon4,
        cBg:"#ec632338",
        title:"Wireframing",
        desc1:"How to archive and unarchive your projects",
        desc2:"How to archive and unarchive your projects"
    },
    {
        icon:icon5,
        cBg:"#ffbf0041",
        title:"Organise projects",
        desc1:"How to archive and unarchive your projects",
        desc2:"A guide to using Folders"
    },
    {
        icon:icon6,
        cBg:"#02eb023b",
        title:"Team administration",
        desc1:"How to invite people to your team",
        desc2:"How to use Groups"
    },
    {
        icon:icon7,
        cBg:"#ff4fc433",
        title:"Billing and plans",
        desc1:"How to upgrade your plan",
        desc2:"Where can I find my invoices/receipts?"
    },
    {
        icon:icon8,
        cBg:"#5dae0042",
        title:"iOS and Android apps",
        desc1:"A guide to getting started with the Hostdesign for Android",
        desc2:"A guide to getting started with the Hostdesign iPhone and iPad app"
    },
    {
        icon:icon9,
        cBg:"#002fff33",
        title:"Security and compliance",
        desc1:"What are your account and project security features?",
        desc2:"Hostdesign is EU hosted"
    },
    {
        icon:icon10,
        cBg:"#02ebb550",
        title:"Hostdesign Enterprise",
        desc1:"What is Hostdesign Enterprise?",
        desc2:"How to get in touch with your dedicated Experience Manager"
    },
    {
        icon:icon1,
        cBg:"#632af21c",
        title:"Collaboration",
        desc1:"How to archive and unarchive your projects",
        desc2:"How to archive and unarchive your projects"
    },
    {
        icon:icon5,
        cBg:"#ffbf0041",
        title:"Organise projects",
        desc1:"How to archive and unarchive your projects",
        desc2:"A guide to using Folders"
    },
]
export const bannerList = [
    'Prototype','Wireframe','Get started','Invoices','Sketch and Hostdesign','Sketch plugins'
];